import { ShieldCheck, Award, Anchor } from "lucide-react";
import soc2Badge from "@/assets/soc2-badge.webp";
import wbencLogo from "@/assets/wbenc-certified-logo.png";

export const ComplianceSection = () => {
  return (
    <section id="compliance" className="py-12 bg-muted/50 scroll-mt-20" aria-labelledby="compliance-heading">
      <div className="container mx-auto px-4">
        <h2 id="compliance-heading" className="text-4xl font-bold text-center mb-4">
          Compassion Meets Compliance
        </h2>
        <p className="text-center text-muted-foreground mb-16 max-w-2xl mx-auto">
          We hold ourselves to the highest standards of security, ethics, and accountability — so our partners and families can feel confident every step of the way.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-card rounded-2xl p-8 text-center shadow-sm border border-border">
            <img src={soc2Badge} alt="SOC 2 Type 2 Certified" className="h-20 w-auto mx-auto mb-6 object-contain" />
            <h3 className="text-xl font-semibold mb-3 text-foreground">SOC 2 Type II Certified</h3>
            <p className="text-muted-foreground">
              Our systems and processes are independently audited to meet rigorous security, availability, and confidentiality standards.
            </p>
          </div>

          <div className="bg-card rounded-2xl p-8 text-center shadow-sm border border-border">
            <img src={wbencLogo} alt="WBENC Certified Women's Business Enterprise" className="h-20 w-auto mx-auto mb-6 object-contain" />
            <h3 className="text-xl font-semibold mb-3 text-foreground">WBENC Certified</h3>
            <p className="text-muted-foreground">
              Proudly certified as a Women's Business Enterprise, reflecting our commitment to diversity and inclusion in the industry.
            </p>
          </div>

          <div className="bg-card rounded-2xl p-8 text-center shadow-sm border border-border">
            <Anchor className="h-20 w-20 mx-auto mb-6 text-primary" />
            <h3 className="text-xl font-semibold mb-3 text-foreground">Trust Center</h3>
            <p className="text-muted-foreground mb-4">
              Explore our policies, certifications, and data practices in detail.
            </p>
            <a href="#" className="text-primary font-medium hover:underline">
              Visit Trust Center →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};